import { render, staticRenderFns } from "./TaskSubtasks.vue?vue&type=template&id=1da13ab7&"
import script from "./TaskSubtasks.vue?vue&type=script&lang=js&"
export * from "./TaskSubtasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports